(() => {
  const mobile = window.matchMedia("(max-width: 749px)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const init = (marquee) => {
    if (marquee.dataset.wpMarqueeReady === "true") return;
    const viewport =
      marquee.querySelector(".wp-review-marquee__viewport") || marquee;
    const track = marquee.querySelector(".wp-review-marquee__track");
    const firstGroup = marquee.querySelector(".wp-review-marquee__group");
    if (!track || !firstGroup) return;

    marquee.dataset.wpMarqueeReady = "true";
    let clone = null;
    let groupWidth = 0;
    let loopEnabled = false;
    let inView = false;
    let active = false;
    let hovering = false;
    let rafId = 0;
    let lastFrame = 0;
    let idleUntil = 0;
    let position = 0;
    let expectedScrollLeft = null;
    let lastViewportWidth = window.innerWidth;

    const ensureClone = () => {
      if (clone && clone.isConnected) return;
      clone = firstGroup.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone
        .querySelectorAll("a")
        .forEach((link) => link.setAttribute("tabindex", "-1"));
      track.appendChild(clone);
    };
    const applyScroll = (x) => {
      position = x;
      expectedScrollLeft = x;
      viewport.scrollLeft = x;
    };
    const measure = () => {
      const rect = firstGroup.getBoundingClientRect().width;
      groupWidth = rect > 0 ? rect : firstGroup.scrollWidth;
      loopEnabled =
        groupWidth > 0 &&
        Boolean(clone && clone.isConnected) &&
        viewport.clientWidth < groupWidth * 0.5;
      return groupWidth;
    };
    const wrap = (x) =>
      x < groupWidth * 0.5
        ? x + groupWidth
        : x > groupWidth * 1.5
          ? x - groupWidth
          : x;
    const centre = () => {
      if (loopEnabled) applyScroll(groupWidth);
    };
    const onScroll = () => {
      if (active && !loopEnabled) measure();
      const x = viewport.scrollLeft;
      if (
        (expectedScrollLeft === null ||
          Math.abs(x - expectedScrollLeft) > 4)
      ) {
        position = x;
        expectedScrollLeft = x;
        if (mobile.matches) idleUntil = performance.now() + 1200;
      }
      if (!loopEnabled) return;
      let target = wrap(x);
      const limit = viewport.scrollWidth - viewport.clientWidth;
      if (x <= 1) target = groupWidth;
      if (limit > 0 && x >= limit - 1) {
        target = Math.max(0, x - groupWidth);
      }
      if (target !== x) applyScroll(target);
    };
    const shouldAnimate = () =>
      inView &&
      active &&
      loopEnabled &&
      !hovering &&
      !reducedMotion.matches &&
      !document.hidden;
    const animate = (now) => {
      if (!shouldAnimate()) {
        rafId = 0;
        return;
      }
      rafId = requestAnimationFrame(animate);
      const elapsed = lastFrame > 0 ? Math.min(64, now - lastFrame) : 0;
      lastFrame = now;
      if (now < idleUntil) return;
      applyScroll(wrap(position + (groupWidth / 200) * (elapsed / 1000)));
    };
    const startLoop = () => {
      if (rafId || !shouldAnimate()) return;
      lastFrame = 0;
      rafId = requestAnimationFrame(animate);
    };
    const stopLoop = () => {
      if (!rafId) return;
      cancelAnimationFrame(rafId);
      rafId = 0;
    };
    const activate = () => {
      if (active) return;
      active = true;
      ensureClone();
      measure();
      marquee.classList.add("is-active");
      centre();
      requestAnimationFrame(() => {
        measure();
        if (loopEnabled && viewport.scrollLeft < 1) centre();
        startLoop();
      });
    };
    const relayout = () => {
      if (!active) return;
      measure();
      centre();
      startLoop();
    };

    viewport.addEventListener("scroll", onScroll, { passive: true });
    marquee.addEventListener(
      "mouseenter",
      () => {
        hovering = true;
        stopLoop();
      },
      { passive: true },
    );
    marquee.addEventListener(
      "mouseleave",
      () => {
        hovering = false;
        startLoop();
      },
      { passive: true },
    );
    mobile.addEventListener?.("change", relayout);
    reducedMotion.addEventListener?.("change", startLoop);
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stopLoop();
      else startLoop();
    });
    window.addEventListener(
      "resize",
      () => {
        if (window.innerWidth === lastViewportWidth) return;
        lastViewportWidth = window.innerWidth;
        relayout();
      },
      { passive: true },
    );
    window.addEventListener("orientationchange", relayout, { passive: true });
    window.addEventListener(
      "load",
      () => {
        if (!active) return;
        const previous = groupWidth;
        measure();
        if (Math.abs(groupWidth - previous) > 1) centre();
        startLoop();
      },
      { passive: true },
    );

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        (entries) => {
          inView = entries.some((entry) => entry.isIntersecting);
          if (inView) {
            activate();
            startLoop();
          } else {
            stopLoop();
          }
        },
        { rootMargin: "300px 0px" },
      ).observe(marquee);
    } else {
      inView = true;
      activate();
      startLoop();
    }
  };

  const scan = () =>
    document.querySelectorAll(".wp-review-marquee").forEach(init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  document.addEventListener("shopify:section:load", scan);
})();
